import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationInputStyle, applyMaxLengths } from "../../constants";
import ApplyRequiredError from "./ApplyRequiredError";
import { updateAppData, updateApplyData } from "../../utils/actionUtils";
import { Box, Stack } from "@mui/material";
import FettiInput from "../FettiInput";
import SimpleApplyField from "./SimpleApplyField";
import ApplyLocationAutocomplete from "./ApplyLocationAutocomplete";
import { valueToPhoneNumber } from "../../utils/utils";
import { Color } from "../../constants";

const styles = {
  header: {
    fontSize: "18px",
  },
  info: {
    fontSize: { xs: "14px", sm: "16px" },
    fontWeight: "bold",
  },
  infoLabel: {
    fontSize: { xs: "14px", sm: "16px" },
    color: Color.secondaryTextGray,
    // minWidth: "100px",
  },
  innerPanel: {
    // padding: 1,
    border: `1px solid #0003`,
    borderRadius: "4px",
  },
  innerTitle: {
    borderBottom: `1px solid #0003`,
    px: 2,
    paddingTop: 1,
    paddingBottom: 1,
  },
  innerPanelStack: {
    px: 2,
    paddingBottom: 2,
    overflowX: "scroll",
  },
  edit: {
    fontSize: "14px",
    color: Color.deepPurple,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const InfoStack = ({ label, value }) => {
  return (
    <Stack direction="row" spacing={1}>
      <Box sx={styles.infoLabel}>{label}:</Box>
      <Box sx={styles.info}>{value}</Box>
    </Stack>
  );
};

const SectionCard = ({ title, onEdit, children }) => {
  return (
    <Stack direction="column" spacing={1} sx={styles.innerPanel}>
      <Stack
        direction="row"
        sx={styles.innerTitle}
        justifyContent="space-between"
        alignItems="center">
        <Box sx={styles.header}>{title}</Box>
        <Box sx={styles.edit} onClick={onEdit}>
          Edit
        </Box>
      </Stack>
      {children}
    </Stack>
  );
};

const ReviewApply = () => {
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.apply.app);
  const serverQuestions = useSelector(
    (state) => state.apply.serverData.questions
  );
  const responses = useSelector((state) => state.apply.app.questions);
  return (
    <>
      <Stack direction="column" spacing={1}>
        <Box sx={ApplicationInputStyle.categoryLabel}>You're all set!</Box>
        <Box sx={ApplicationInputStyle.subheader}>
          Review your information and submit
        </Box>
      </Stack>
      <SectionCard
        title="Contact Info"
        onEdit={() => updateApplyData(dispatch, { step: 0 })}>
        <Stack direction="column" spacing={1} sx={styles.innerPanelStack}>
          <InfoStack
            label="Name"
            value={`${appData.firstName} ${appData.lastName}`}
          />
          <InfoStack label="Email" value={appData.email} />
          <InfoStack
            label="Phone Number"
            value={appData.phone ? valueToPhoneNumber(appData.phone) : "None"}
          />
          <InfoStack
            label="Location"
            value={appData.location ? appData.location : "None"}
          />
        </Stack>
      </SectionCard>
      <SectionCard
        title="Resume"
        onEdit={() => updateApplyData(dispatch, { step: 1 })}>
        <Stack direction="column" spacing={1} sx={styles.innerPanelStack}>
          <InfoStack label="Selected" value={`${appData.resume[1]}`} />
        </Stack>
      </SectionCard>
      {serverQuestions && serverQuestions.length > 0 && (
        <SectionCard
          title="Employer Questions"
          onEdit={() => updateApplyData(dispatch, { step: 2 })}>
          <Stack direction="column" spacing={1} sx={styles.innerPanelStack}>
            {serverQuestions.map((question, index) => {
              return (
                <Stack direction="column" spacing={1}>
                  <Box>
                    {/* <strong>Q:</strong> */}
                    {" " + question.question}
                  </Box>
                  <Box sx={{ color: Color.secondaryTextGray }}>
                    <strong style={{ color: "black" }}>A:</strong>
                    {" " + responses[index]}
                  </Box>
                </Stack>
              );
            })}
          </Stack>
        </SectionCard>
      )}
    </>
  );
};

export default ReviewApply;
